<template>
  <div class="main-container row">
    <div class="col-1-of-2 price-chart">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 611.24 520.24">
            <defs>
              <!-- SVG style below -->
            </defs>
            <title></title>
            <g id="Text" class="draw-lens-text">
                <text class="cls-1" transform="translate(337.22 501.43)">ONE CLICK PU<tspan class="cls-2" x="161.95" y="0">R</tspan><tspan x="178.29" y="0">CH</tspan><tspan class="cls-3" x="212.73" y="0">A</tspan><tspan x="230.04" y="0">SE</tspan>
                </text>
            </g>
            <g id="price-frame">
                <rect id="frame" class="cls-4" x="19.49" y="54.24" width="591.75" height="357.87" rx="26.35"/>
            </g>
            <g id="price-line">
                <polyline id="price" class="cls-5 draw-price" points="11.58 369.02 108.85 268.78 159.72 325.06 224.87 223.06 261.46 490.36 298.05 120.19 392.65 187.89 547.93 5"/>
            </g>
            <g id="covers">
                <rect id="conver-price" class="cls-6" y="349.86" width="19.08" height="35.3"/>
            </g>
            <g id="price-lens">
                <circle class="cls-7 draw-lens-circle" cx="260.19" cy="485.3" r="31.43"/>
                <polyline class="cls-8 draw-lens-line" points="284.81 504.63 322.38 467.06 413.84 467.06"/>
            </g>
        </svg>
    </div> <!-- Graph col-1-of-2 -->

    <div class="col-1-of-2 header">
        <div class="header__title">Buy the dip</div>
        <div class="header__list">
            <div class="header__item">
                <img class="header__icon header__icon--1" src="../assets/ability_swiftness.png">
                <span class="header__text header__text--1">Blazing fast</span>
            </div>
            <div class="header__item">
                <img class="header__icon header__icon--2" src="../assets/ability_opportunity.png">
                <span class="header__text header__text--2">Every opportunity</span>
            </div>
            <div class="header__item">
                <img class="header__icon header__icon--3" src="../assets/ability_true-strike.png">
                <span class="header__text header__text--3">Never miss out</span>
            </div>
        </div>
        <div class="header__button-wrapper">
            <router-link to="/tables" class="button button--big">go to tables</router-link>
        </div>
    </div> <!-- Header col-1-of-2 -->
</div> <!-- Main container / row -->
</template>

<!-- SVG style -->
<style>.cls-1{font-size:24px;fill:#fff;font-family:NunitoSans-Regular, Nunito Sans;}.cls-2{letter-spacing:0em;}.cls-3{letter-spacing:-0.01em;}.cls-4{fill:#444;}.cls-5,.cls-7,.cls-8{fill:none;}.cls-5{stroke:#ad2371;stroke-width:10px;}.cls-5,.cls-8{stroke-linecap:round;stroke-linejoin:round;}.cls-6{fill:#333;}.cls-7,.cls-8{stroke:#00c0ff;stroke-width:7px;}.cls-7{stroke-miterlimit:10;}</style>

<script>
// @ is an alias to /src
</script>
